.actions {
  background-color: var(--colors-grays-white);
}

.actions--sticky {
  padding-top: 16px;
  padding-bottom: 24px;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
}

.text {
  font-size: 15px;
}
